import { type FunctionalComponent, h } from "preact";
import { ResponsiveImage } from "@shared/Components";
import type { ArticleModel } from "../magazine.service";

type CardContext = "Magazine" | "Related";
type CardContextCssClass = { [Key in CardContext]: string };
const CssContextMap: CardContextCssClass = {
  Magazine: "magazine-card",
  Related: "related-card",
};

export interface ArticleCardProps {
  article: ArticleModel;
  context: CardContext;
  showIngress?: boolean;
  lazyLoadImage?: boolean;
}

export const ArticleCard: FunctionalComponent<ArticleCardProps> = ({
  article,
  context,
  showIngress = true,
  lazyLoadImage = true,
}: ArticleCardProps) => {
  const tag = article.tag ? article.tag[0] : "";
  const cssClass = CssContextMap[context];
  const sizes = context === "Related" ? "(min-width: 768px) 350px, 100px" : "(min-width: 1024px) 700px, 100vw";
  return (
    <div className={cssClass}>
      <a className={`${cssClass}__item `} href={article.url}>
        <span className={`${cssClass}__item__image`}>
          <span className="responsive-image">
            <ResponsiveImage
              src={article.imageUrl}
              alt={article.imageAltText}
              sizes={sizes}
              loading={lazyLoadImage ? "lazy" : "eager"}
              quality={article.imageQuality}
            />
          </span>
        </span>
        <span className={`${cssClass}__item__tag`}>{tag}</span>
        <span
          className={`${cssClass}__item__title ${showIngress ? "" : `${cssClass}__item__title--no-ingress`}`}
          dangerouslySetInnerHTML={{
            __html: article.title,
          }}
        />
        <span
          className={`${cssClass}__item__ingress ${showIngress ? "" : "hidden"}`}
          dangerouslySetInnerHTML={{
            __html: article.text,
          }}
        />
      </a>
    </div>
  );
};
